/**
 * Centralized localStorage keys + typed accessors used by the EditTicket view.
 */
export const EDIT_TICKET_STORAGE_KEYS = {
  sideViewFilterIndex: 'widget_ticket_view_id',
  activeMenuKey: 'ticket_detail_active_menu_index',
  customFormLocation: 'TikitCustomFormLocation',
  headerCollapsed: 'ticket_detail_header_collapsed',
  editPanelCollapsed: 'ticket_edit_panel_collapsed',
  // The phone's card starts compact, so what is remembered there is the opposite choice.
  mobileCardExpanded: 'ticket_detail_mobile_card_expanded'
} as const;

type PaneFlagKey =
  | typeof EDIT_TICKET_STORAGE_KEYS.headerCollapsed
  | typeof EDIT_TICKET_STORAGE_KEYS.editPanelCollapsed
  | typeof EDIT_TICKET_STORAGE_KEYS.mobileCardExpanded;

// Storage can be blocked or throw (private windows, cleared site data); a pane then simply
// opens in its default state and forgets, which is the safe way round.
export const getPaneFlag = (key: PaneFlagKey): boolean => {
  try {
    return localStorage.getItem(key) === 'true';
  } catch {
    return false;
  }
};

export const setPaneFlag = (key: PaneFlagKey, on: boolean): void => {
  try {
    if (on) localStorage.setItem(key, 'true');
    else localStorage.removeItem(key);
  } catch {
    /* storage blocked */
  }
};

export const getSideViewFilterIndex = (): number => {
  const raw = localStorage.getItem(EDIT_TICKET_STORAGE_KEYS.sideViewFilterIndex);
  const parsed = parseInt(raw || '0');
  return Number.isFinite(parsed) ? parsed : 0;
};

export const setSideViewFilterIndex = (index: number): void => {
  localStorage.setItem(EDIT_TICKET_STORAGE_KEYS.sideViewFilterIndex, index.toString());
};

export const getActiveMenuKey = (): string =>
  localStorage.getItem(EDIT_TICKET_STORAGE_KEYS.activeMenuKey) || 'activity';

export const setActiveMenuKey = (key: string): void => {
  localStorage.setItem(EDIT_TICKET_STORAGE_KEYS.activeMenuKey, key);
};

export const isCustomFormTabLocation = (): boolean =>
  (localStorage.getItem(EDIT_TICKET_STORAGE_KEYS.customFormLocation) || 'tab') === 'tab';
